// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ForbiddenErrorSchema } from './v1/forbiddenErrorSchema';
import { v1InvoiceSchema } from './v1/invoiceSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1UnprocessableEntityErrorSchema } from './v1/unprocessableEntityErrorSchema';

export const exportInvoiceToIntegrationPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
  app_id: z.number().int().describe("AppUser id"),
  id: z.number().int().describe("Invoice id"),
});

export const exportInvoiceToIntegrationHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description Invoice exported successfully
 */
export const exportInvoiceToIntegration200Schema = z.lazy(() => v1InvoiceSchema);

/**
 * @description Forbidden - Insufficient permissions
 */
export const exportInvoiceToIntegration403Schema = z.lazy(() => v1ForbiddenErrorSchema);

/**
 * @description Invoice not found
 */
export const exportInvoiceToIntegration404Schema = z.lazy(() => v1NotFoundErrorSchema);

/**
 * @description Unprocessable Entity - Invoice already synced or export error
 */
export const exportInvoiceToIntegration422Schema = z.lazy(() => v1UnprocessableEntityErrorSchema);

export const exportInvoiceToIntegrationMutationResponseSchema = z.lazy(() => exportInvoiceToIntegration200Schema);
